import { IQuestion } from '../pages/task/types';

import {
  HomeIcon,
  TasksIcon,
  // TipsIcon,
  // TestIcon,
} from '../components/shared/CustomIcons';
import { DASHBOARD_PATH, TASKS_PATH } from './paths';
import imgLabExperiment from '/images/lab-experiment-magenta.svg';
import imgProductNewsletter from '/images/product-newsletter-magenta.svg';
import imgVirtualMeetings from '/images/virtual-meeting-magenta.svg';
import { TQuestionType } from './types';

// Registration
export const BUTTON_CREATE_ACCOUNT = 'Create Account';
export const BUTTON_ENTER = 'Enter';
export const EYE_OPS_IMAGE_PATH = '/images/ops.svg';
export const WELCOME_TEXT = 'Welcome to Eye Op patient platform';

// Email
export const EMAIL_LABEL = 'Email';
export const EMAIL_PROMPT_TITLE = 'Your booking email';
export const EMAIL_PROMPT_DESCRIPTION =
  'Please enter the email you used when booking your appointment';
export const BUTTON_CONTINUE = 'Continue';
export const EMAIL_ALREADY_REGISTERED_HEADING =
  'Great! Your email is already registered to the system.';
export const EMAIL_ALREADY_REGISTERED_MESSAGE =
  'Simply enter your account with the email and password you created while booking your appointment.';
export const BUTTON_ENTER_ACCOUNT = 'Enter your account';

// OTP
export const OTP_TITLE = 'We just sent you a verification code';
export const OTP_RESEND_TEXT = `Didn't receive the code?`;
export const OTP_INPUT_PLACEHOLDER = 'Enter the code we sent to {email}';
export const CONFIRM_BUTTON_TEXT = 'Confirm';
export const RESEND_TIMER_WARNING = 'Wait {timer}s to resend';

// Surgery Info
export const TEXT_ABOUT_YOUR_SURGERY = 'About your surgery';
export const TEXT_LEARN_PREPARE =
  'Learn how other patients felt about thier surgery';

export const TEXT_SURGERY_DETAILS = 'YOUR SURGERY DETAILS';
export const TEXT_PRE_SURGERY_CHECKLIST = 'Pre-surgery checklist';
export const TEXT_PREPARATION_INSTRUCTIONS = 'Preparation instructions';
export const TEXT_LEARN_ABOUT_SURGERY = 'Learn about your surgery';
export const TEXT_TESTIMONIALS = 'Testimonials';
export const TEXT_PATIENTS_SAY =
  'What other patients have to say about your surgery?';
export const IMG_PRE_SURGERY_CHECKLIST = '/images/marketing-filling-survey.svg';
export const IMG_PREPARATION_INSTRUCTIONS =
  '/images/preparation-instructions.svg';
export const IMG_EDUCATION_ONLINE_LEARNINGS =
  '/images/education-online-learnings.svg';

// Introduction View
export const INTRODUCTION_STEPS = [
  {
    label: 'We help you with your eye health',
    description: `Explore a range of resources, exercises, and tests tailored to optimize your vision.`,
    image: {
      path: imgLabExperiment,
      alt: 'lab-experiment',
    },
  },
  {
    label: 'Stay in touch with your clinician',
    description:
      'Stay in touch with your clinical team for expert guidance and personalized care on your journey to clearer vision.',
    image: {
      path: imgProductNewsletter,
      alt: 'product-Newsletter',
    },
  },
  {
    label: 'Hear the stories of the other patients',
    description: 'Gain insight and support: hear from those who’ve been there.',
    image: {
      path: imgVirtualMeetings,
      alt: 'virtual-Meetings',
    },
  },
];

export const SKIP_BUTTON = 'Skip';

// Dashboard
export const APPOINTMENT_STATUS = {
  CONFIRM: 'confirm',
};

export const BUTTON_DISCOVER_MORE = 'Discover more';
export const TEXT_HOW_ARE_YOU_FEELING = 'How are you feeling today?';
export const TEXT_UPCOMING_EVENT = 'Upcoming Event';

// APP Menu

export const APP_MENUS = [
  {
    label: 'Home',
    path: DASHBOARD_PATH,
    icon: HomeIcon,
  },
  {
    label: 'Tasks',
    path: TASKS_PATH,
    icon: TasksIcon,
  },
  // {
  //   label: 'Tips',
  //   path: '/tips',
  //   icon: TipsIcon,
  //   disabled: true,
  // },
  // {
  //   label: 'Test',
  //   path: '/test',
  //   icon: TestIcon,
  //   disabled: true,
  // },
];

export const QUESTION_TYPE: Record<string, TQuestionType> = {
  MULTITEXT: 'multiText',
  DATE: 'date',
  NUMERICFIELD: 'numericField',
  RADIO: 'radio',
  TEXTAREA: 'textarea',
  TEXTFIELD: 'textField',
  SELECT_YEAR: 'selectYear',
};

export const MULTITEXT_SUBQUESTION: IQuestion = {
  answer: [],
  sub_questions: [],
  id: 999999,
  question:
    'Do you want to add any additional operations or hospital admissions ?',
  question_type: 'radio',
  options: ['Yes', 'No'],
  parent_question_id: null,
  placeholder: null,
  label: null,
  condition: QUESTION_TYPE.MULTITEXT,
};

// QUestionnaires History type
export const HISTORY_TYPE = {
  DAILY_LIVING: 'daily_living',
  FAMILY: 'family',
  HOSPITAL_EXPERIENCE: 'hospital_experience',
  LIFESTYLE: 'lifestyle',
  MEDICAL: 'medical',
};

// Question statement
export const WEIGHT = 'Weight';
export const HEIGHT = 'Height';
export const BMI = 'BMI (if known)';

export const DAY_OF_WEEK: Record<string, string> = {
  Sunday: 'S',
  Monday: 'M',
  Tuesday: 'T',
  Wednesday: 'W',
  Thursday: 'T',
  Friday: 'F',
  Saturday: 'S',
};
